import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import loadLegalDocument from '../service/legalApi';
const NAVIGATION = [['privacy', 'Политика данных'], ['personal-data-consent', 'Согласие на обработку'], ['cookies', 'Cookies и аналитика'], ['terms', 'Соглашение'], ['rules', 'Правила'], ['contacts', 'Связь']];
export default class LegalPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.slug = window.location.pathname.replace(/^\/+|\/+$/g, '') || 'rules';
    this.page = null;
    this.loading = true;
    loadLegalDocument(this.slug).then(response => {
      this.page = response.data;
      app.setTitle(this.page.title);
    }).catch(() => {
      this.page = null;
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m('main.dc-container', m('div.dc-legal__document', 'Загружаем документ…'));
    }
    if (!this.page) {
      return m('main.dc-container', m('div.dc-legal__document', [m('h1', 'Документ не найден'), m('a', {
        href: '/rules'
      }, 'Открыть правила')]));
    }
    return m('main.dc-legal', {
      'aria-labelledby': 'dc-legal-title'
    }, [m('header.dc-legal__hero', m('div.dc-container', [m('span.dc-legal__eyebrow', 'Документы DevConnect'), m('h1#dc-legal-title', this.page.title), m('p', this.page.description), m('small', `Последнее обновление: ${this.page.updated} · версия ${this.page.version}`)])), m('div.dc-container.dc-legal__layout', [m('nav.dc-legal__nav', {
      'aria-label': 'Документы сайта'
    }, NAVIGATION.map(_ref => {
      let [slug, title] = _ref;
      return m('a', {
        href: `/${slug}`,
        className: this.slug === slug ? 'is-active' : ''
      }, title);
    })),
    // Все значения вставляются текстовыми Mithril-узлами: содержание документа не может исполнить HTML или JavaScript.
    m('article.dc-legal__document', this.page.sections.map(_ref2 => {
      let [heading, paragraphs] = _ref2;
      return m('section', [m('h2', heading), paragraphs.map(paragraph => m('p', paragraph))]);
    }))])]);
  }
}
flarum.reg.add('devconnect-legal', 'forum/components/LegalPage', LegalPage);